<div
  routerLink="{{ route }}"
  class="tw-flex tw-justify-between tw-items-center tw-px-3 tw-cursor-pointer my-2"
>
  <div class="tw-w-3/4 tw-flex tw-items-center tw-gap-2">
    <img class="tw-w-[32px]" src="{{ icon }}" alt="" />
    <span class="tw-text-primary">{{ label | translate }}</span>
  </div>
  <div class="tw-w-1/4 tw-flex tw-justify-end tw-items-center">
    @if (isArabic) {<i
      class="bi bi-chevron-left tw-mr-3 tw-text-xl tw-text-primary"
    ></i
    >} @else {<i
      class="bi bi-chevron-right tw-ml-3 tw-text-xl tw-text-primary"
    ></i
    >}
  </div>
</div>
